(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slideshows = document.querySelectorAll('[data-slideshow="true"]');
    
    slideshows.forEach(slideshow => {
      const slides = slideshow.querySelectorAll('.hero__slide');
      const dots = slideshow.querySelectorAll('.hero__slideshow-dot');
      const interval = parseInt(slideshow.dataset.autoplayInterval) || 6000;
      let currentIndex = 0;
      let autoplayTimer;

      function goToSlide(index) {
        // Remove active class from all slides and dots
        slides.forEach(slide => slide.classList.remove('hero__slide--active'));
        dots.forEach(dot => dot.classList.remove('hero__slideshow-dot--active'));
        
        // Add active class to current slide and dot
        if (slides[index]) {
          slides[index].classList.add('hero__slide--active');
        }
        if (dots[index]) {
          dots[index].classList.add('hero__slideshow-dot--active');
        }
        
        currentIndex = index;
      }

      function nextSlide() {
        const nextIndex = (currentIndex + 1) % slides.length;
        goToSlide(nextIndex);
      }

      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, interval);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
        }
      }

      // Add click handlers to dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          startAutoplay(); // Reset autoplay timer on manual navigation
        });
      });

      // Start autoplay if there are multiple slides
      if (slides.length > 1) {
        startAutoplay();
      }

      // Pause on hover (optional - improves UX)
      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Scroll to reviews: ensure #product-reviews target exists and handle rating link clicks
  (function() {
    function setProductReviewsId() {
      if (document.getElementById('product-reviews')) return;
      var section = document.querySelector('.product-information');
      if (!section) return;
      var rows = section.querySelectorAll('accordion-custom');
      for (var i = 0; i < rows.length; i++) {
        var summary = rows[i].querySelector('summary');
        if (summary && /reviews?/i.test(summary.textContent.trim())) {
          rows[i].id = 'product-reviews';
          return;
        }
      }
      var byId = section.querySelector('[id*="review"], [id*="Review"]');
      if (byId) {
        byId.id = 'product-reviews';
        return;
      }
      var container = section.querySelector('.product-information__accordion-container');
      if (container) container.id = 'product-reviews';
      var firstAccordion = section.querySelector('.accordion');
      if (firstAccordion) firstAccordion.id = 'product-reviews';
    }

    function doScrollToReviews() {
      setProductReviewsId();
      var target = document.getElementById('product-reviews');
      if (!target) return;
      var isMobile = window.innerWidth < 750;
      var offset = isMobile ? 16 : 100;
      target.style.scrollMarginTop = offset + 'px';
      requestAnimationFrame(function() {
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
          var y = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        if (isMobile) {
          setTimeout(function() {
            var details = target.querySelector && target.querySelector('details');
            if (details && !details.open) details.open = true;
          }, 400);
        }
      });
    }

    function scrollToReviews(e) {
      var ratingLink = e.target.closest && e.target.closest('a.rating-wrapper-link[href="#product-reviews"]');
      if (!ratingLink) {
        if (e.target.classList && e.target.classList.contains('group-block__link')) {
          var linkUnder = document.querySelector('.product-details a.rating-wrapper-link[href="#product-reviews"]');
          if (linkUnder) {
            var r = linkUnder.getBoundingClientRect();
            if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
              e.preventDefault();
              e.stopPropagation();
              doScrollToReviews();
            }
          }
        }
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      doScrollToReviews();
    }
    document.addEventListener('click', scrollToReviews, true);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setProductReviewsId);
    } else {
      setProductReviewsId();
    }
    setTimeout(setProductReviewsId, 1000);
  })();

  // Clean up pipe separators and split specs from description when Liquid split failed.
  function splitSpecsFromDescription() {
    // Find accordion rows by heading text
    var allAccordions = document.querySelectorAll('.product-information accordion-custom, .product-information__accordion-container accordion-custom');
    var descAccordion = null;
    var specsAccordion = null;

    allAccordions.forEach(function(acc) {
      var summary = acc.querySelector('summary');
      if (!summary) return;
      var text = summary.textContent.trim().toLowerCase();
      if (text === 'description') descAccordion = acc;
      if (text.indexOf('details') !== -1 || text.indexOf('dimensions') !== -1) specsAccordion = acc;
    });

    if (!descAccordion || !specsAccordion) return;

    var descContent = descAccordion.querySelector('.details-content');
    var specsContent = specsAccordion.querySelector('.details-content');
    if (!descContent || !specsContent) return;

    // --- Step 1: If specs tab already has content, Liquid split worked ---
    //             Just clean up any leftover pipe characters and we're done.
    if (specsContent.textContent.trim().length > 10) {
      removePipeSeparators(descContent);
      removePipeSeparators(specsContent);
      return;
    }

    // --- Step 2: Liquid split failed. Try to find a pipe element in Description
    //             and use it as the split point (everything after pipe → specs tab).
    if (splitOnPipe(descContent, specsContent)) {
      removePipeSeparators(descContent);
      removePipeSeparators(specsContent);
      return;
    }

    // --- Step 3: No pipe found. Fall back to spec-label detection ---
    splitOnSpecLabels(descContent, specsContent);
    removePipeSeparators(descContent);
    removePipeSeparators(specsContent);
  }

  // All element types that might wrap a pipe separator
  var PIPE_SELECTORS = 'p, div, span, strong, b, em, h1, h2, h3, h4, h5, h6';

  // Remove elements that are just a pipe character (|) from a container
  function removePipeSeparators(container) {
    // Search all descendant elements for pipe-only content
    var allEls = container.querySelectorAll(PIPE_SELECTORS);
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      if (el.textContent.trim() === '|') {
        // Walk up to find the highest ancestor that is still just a pipe
        var target = el;
        while (target.parentElement &&
               target.parentElement !== container &&
               target.parentElement.textContent.trim() === '|') {
          target = target.parentElement;
        }
        target.remove();
      }
    }
    // Also clean inline pipe characters that sit between <br> tags
    var html = container.innerHTML;
    html = html.replace(/<br\s*\/?>\s*\|\s*<br\s*\/?>/gi, '<br>');
    html = html.replace(/<br\s*\/?>\s*<(strong|b|em|span)[^>]*>\s*\|\s*<\/\1>\s*<br\s*\/?>/gi, '<br>');
    if (html !== container.innerHTML) {
      container.innerHTML = html;
    }
  }

  // Find the pipe element anywhere in the tree and return the top-level
  // sibling-level element to use as the split point.
  function findPipeElement(container) {
    var allEls = container.querySelectorAll(PIPE_SELECTORS);
    for (var i = 0; i < allEls.length; i++) {
      if (allEls[i].textContent.trim() === '|') {
        // Walk up to the highest ancestor whose entire text is just the pipe
        var target = allEls[i];
        while (target.parentElement &&
               target.parentElement !== container &&
               target.parentElement.textContent.trim() === '|') {
          target = target.parentElement;
        }
        return target;
      }
    }
    return null;
  }

  // Try to split description content at a pipe-containing element
  function splitOnPipe(descContent, specsContent) {
    var pipeEl = findPipeElement(descContent);
    if (!pipeEl) return false;

    // The pipe might be nested inside a wrapper div (from custom-liquid block).
    // We need to split at the sibling level within the pipe's parent.
    var parent = pipeEl.parentElement;

    // Collect siblings after the pipe
    var siblingsAfter = [];
    var next = pipeEl.nextElementSibling;
    while (next) {
      siblingsAfter.push(next);
      next = next.nextElementSibling;
    }

    // Verify there's content before and after the pipe
    if (!pipeEl.previousElementSibling || siblingsAfter.length === 0) return false;

    // Remove the pipe
    pipeEl.remove();

    // Move everything after the pipe to the specs tab
    specsContent.innerHTML = '';
    for (var i = 0; i < siblingsAfter.length; i++) {
      specsContent.appendChild(siblingsAfter[i]);
    }
    return true;
  }

  // Primary labels — match with or without colon (highest priority)
  var PRIMARY_LABELS = ['Dimensions', 'Specifications', 'Specification'];
  // Secondary labels — only match with a colon after them
  var SECONDARY_LABELS = [
    'Care Instructions', 'Please note', 'Assembly service',
    'Material', 'Weight', 'Design', 'Style', 'Assembly',
    'Color', 'Colour', 'Finish', 'Size', 'Height', 'Width', 'Depth',
    'Capacity', 'Power', 'Voltage', 'Warranty', 'Care', 'Features',
    'Includes', 'Package', 'Origin', 'Brand', 'Made', 'Type', 'Model',
    'Fabric', 'Frame', 'Legs', 'Seat', 'Back', 'Arms', 'Base',
    'Cushion', 'Fill', 'Upholstery'
  ];

  // Check if an element's text starts with a spec label.
  // Returns true for primary labels (with or without colon)
  // and secondary labels (with colon only).
  function textStartsWithLabel(text) {
    var t = text.trim();
    for (var i = 0; i < PRIMARY_LABELS.length; i++) {
      if (t.indexOf(PRIMARY_LABELS[i]) === 0) return true;
    }
    for (var i = 0; i < SECONDARY_LABELS.length; i++) {
      if (t.indexOf(SECONDARY_LABELS[i] + ':') === 0) return true;
      if (t.indexOf(SECONDARY_LABELS[i] + ' :') === 0) return true;
    }
    return false;
  }

  // Find the first element in DOM order whose text starts with a spec label.
  // Searches all descendants recursively, then walks up to the sibling level.
  function findFirstSpecElement(container) {
    var allEls = container.querySelectorAll(PIPE_SELECTORS);
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      var text = el.textContent.trim();
      if (!textStartsWithLabel(text)) continue;
      // Walk up to the highest ancestor whose text also starts with the label
      var target = el;
      while (target.parentElement &&
             target.parentElement !== container &&
             textStartsWithLabel(target.parentElement.textContent.trim())) {
        target = target.parentElement;
      }
      return target;
    }
    return null;
  }

  // Split on the first spec label found in the description content.
  function splitOnSpecLabels(descContent, specsContent) {
    var specEl = findFirstSpecElement(descContent);
    if (!specEl) return;

    // Must have content before it (don't empty the description tab)
    if (!specEl.previousElementSibling) return;

    var parent = specEl.parentElement;

    // Collect this element and all siblings after it
    var toMove = [];
    var current = specEl;
    while (current) {
      toMove.push(current);
      current = current.nextElementSibling;
    }

    if (toMove.length === 0) return;

    // Move to specs tab
    specsContent.innerHTML = '';
    for (var i = 0; i < toMove.length; i++) {
      specsContent.appendChild(toMove[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitSpecsFromDescription);
  } else {
    splitSpecsFromDescription();
  }

  // Move accordions below media gallery on desktop
  function moveAccordionsOnDesktop() {
    const mediaQuery = window.matchMedia('(min-width: 750px)');
    
    function handleAccordions(e) {
      const grids = document.querySelectorAll('.product-information__grid.product-information--media-left');
      
      grids.forEach(grid => {
        const media = grid.querySelector('.product-information__media');
        const accordions = grid.querySelectorAll('.product-details .accordion');
        let container = grid.querySelector('.product-information__accordion-container');
        
        if (e.matches) {
          // Desktop: Move accordions below media
          if (!container && accordions.length > 0) {
            container = document.createElement('div');
            container.className = 'product-information__accordion-container';
            media.after(container);
          }
          
          if (container) {
            accordions.forEach(accordion => {
              // Store original parent for mobile restore
              if (!accordion.dataset.originalParent) {
                accordion.dataset.originalParent = 'product-details';
              }
              container.appendChild(accordion);
            });
          }
        } else {
          // Mobile: Move accordions back to product details
          if (container) {
            const productDetails = grid.querySelector('.product-details .group-block');
            if (productDetails) {
              accordions.forEach(accordion => {
                productDetails.appendChild(accordion);
              });
            }
            container.remove();
          }
        }
      });
    }
    
    // Run on load and on resize
    handleAccordions(mediaQuery);
    mediaQuery.addEventListener('change', handleAccordions);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveAccordionsOnDesktop);
  } else {
    moveAccordionsOnDesktop();
  }

  } catch(e) { console.error(e); }
})();
})();
